import {Component, Vue} from 'vue-property-decorator'
import {UserModule} from '@/store/modules/user'
import {
    delFinanceRepeatOrderById,
    financeRepeatOrderExportData, getFinanceRepeatOrderList, setFinanceRepeatOrderStatus
} from '@/api/financial-center'
import {menuBtn} from '@/utils/menu_level2_button'
import {delNullProperty} from "@/utils";
import {
    gettHeaderByType, settHeaderByType
} from '@/api/common'

@Component({})
export default class RepeatOrder extends Vue {
    delOrderId: number = null
    delOrderDialogShow = false
    tableData = []
    tableRandom = Math.random()
    tableLoading = false
    page = 1
    limit = 20
    total = 0
    cancelApproveDialog = false
    reviewId = NaN
    action = ''
    exportButtonDisabled = false
    menuBtn = menuBtn
    types = '1'

    //新
    // tableHeadFilter = {
    filter_directorUserIdList = []
    filter_status= ''
    filter_code= ''
    filter_financeOrderCode= ''
    filter_customerType= ''
    filter_customerName= ''
    // }
    tableHead: any[] = []
    tableHeadPopoverShow = false
    tableKey = Math.random()
    timer = null
    // isReadonly = false
    draggableList = []
    draggableListChange = []

    // computed
    get userList() {
        return UserModule.userList
    }

    /* created */
    created() {
        this.gettHeaderByType()
    }

    async gettHeaderByType() {
        const data: any = await gettHeaderByType(15)
        this.draggableList = data.headerUserList
        this.tableHead = JSON.parse(JSON.stringify(data.headerUserList))
        this.draggableListChange = JSON.parse(JSON.stringify(data.headerUserList))
        this.getTableData()
    }

    // 列表
    async getTableData() {
        this.tableLoading = true

        const obj = {
            limit: this.limit,  //条数/页
            page: this.page, //页码
            directorUserIdList: this.filter_directorUserIdList,// 负责人id
            status: this.filter_status,  // 撞单状态 // '0'-审批中, '1'-已通过, '2'-未通过, '3'-未提交, '4'-已撤回 允许值: '0', '1', '2', '3', '4'
            financeOrderCode: this.filter_financeOrderCode,  // 订单编号
            code: this.filter_code,  // 	    撞单编号
            customerType: this.filter_customerType,  // 客户类型 // 'customerConversion'-转化客户, 'customerBusiness'-B端客户    允许值: 'customerConversion', 'customerBusiness'
            customerName: this.filter_customerName,  // 客户名称
        }

        const data: any = await getFinanceRepeatOrderList(delNullProperty(obj))
        this.tableData = data.financeRepeatOrderList
        this.total = data.allNum
        this.tableKey = Math.random()
        this.$nextTick(() => {
            (this.$refs.multipleTable as HTMLFormElement).doLayout();
            (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
        });
        this.tableLoading = false

    }

    // 导出
    async exportExcel() {
        this.exportButtonDisabled = true
        this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        const obj = {
            customerName: this.filter_customerName,
            customerType: this.filter_customerType,
            code: this.filter_code,
            financeOrderCode: this.filter_financeOrderCode,
            status: this.filter_status,
            directorUserIdList: this.filter_directorUserIdList,
        }

        financeRepeatOrderExportData(delNullProperty(obj)).finally(() => {
            this.exportButtonDisabled = false
        })
    }

    /*
    * 统计报表*/
    openDtatisticsData() {
        window.open(window.location.origin + this.$route.matched[0].path + '/repeatOrderStatic', '_blank')
    }

    handle() {
        document.body.click()
    }

    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData()
        }, 1000)
    }

    pageSizeChange(limit: number) {
        this.limit = limit
        this.getTableData();
    }

    /*
    按钮权限验证
    */
    handleBtn(id: number) {
        return menuBtn(id)
    }


    /*新建费用*/
    openNewRepeatOrder() {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/repeatOrderAdd', '_blank')
        const timer = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(timer)
            }
        }, 500)
    }

    clickEditButton(row) {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/repeatOrderInfo?id=' + row.id + '&status=' + row.status+ '&isShow=' + row.isShow  + '&type=编辑' + '&isUpdatedData=0', '_blank')
        const timer = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(timer)
            }
        }, 500)
    }


    clickCancelApproveDialogConfirmButton(row) {
        if (this.action === '0') {
            const win = window.open(window.location.origin + this.$route.matched[0].path + '/repeatOrderInfo?id=' + row.id + '&status=' + row.status+ '&isShow=' + row.isShow + '&type=编辑' + '&isUpdatedData=1', '_blank')
            const timer = setInterval(() => {
                if (win.closed) {
                    this.getTableData()
                    clearInterval(timer)
                }
            }, 500)
            return
        } else {
            setFinanceRepeatOrderStatus({
                id: this.reviewId,
                action: this.action
            }).then(() => {
                this.$message.success(`成功${this.action === '0' ? '提交' : '撤回'}审批`)
                this.getTableData()
                this.cancelApproveDialog = false
            }).catch((err: Error) => {
                // 没有查到相关审批流程，暂时无法新建订单，请联系管理员设置审批流程
                if (err.message === '审批流报错') {
                    this.$message.error('此审批流程不适用您，请联系管理员')
                }
            })
        }
    }

    // 撤回撞单审批
    async setFinanceMarketCostStatus(row: any, action: string) {
        this.reviewId = row.id
        this.action = action
        if (action === '0') {
            this.clickCancelApproveDialogConfirmButton(row)
        } else {
            this.cancelApproveDialog = true
        }
    }


    hendleDelClick(id) {
        this.delOrderId = id
        this.delOrderDialogShow = true
    }

    // 确定删除
    async delOrderDialogConfirm() {
        await delFinanceRepeatOrderById(this.delOrderId)
        this.$message.success('删除成功')
        this.delOrderDialogShow = false
        this.getTableData()
    }

    // 点击表格进入详情
    clickRow(row: any, cloumn: any) {
        if (menuBtn(165)) {
            const win = window.open(window.location.origin + this.$route.matched[0].path + '/repeatOrderInfo?id=' + row.id + '&status=' + row.status+ '&isShow=' + row.isShow + '&isUpdatedData=0', '_blank')
            const timer = setInterval(() => {
                if (win.closed) {
                    this.getTableData()
                    clearInterval(timer)
                }
            }, 500)
        } else {
            this.$message.error('您没有查看权限');
        }
    }

    // 设置表头
    async draggableEnd() {
        this.tableHeadPopoverShow = false
        this.draggableList = this.draggableListChange
        const newArr: object = this.draggableList.filter(item =>
            item.isShow === true
        )
        if ((newArr as []).length > 0) {
            await settHeaderByType({types: 15, headerIds: this.draggableList})
            this.$message.success('表头设置成功')
            this.gettHeaderByType()
        } else {
            this.$message.error('至少保留一个表头')
        }
    }

    doCancel(){
        this.draggableListChange = JSON.parse(JSON.stringify( this.draggableList))
        this.tableHeadPopoverShow = false
    }

    changeTable() {
        const newArr = []
        this.draggableListChange.forEach(item => {
            if (item.isShow === true) {
                newArr.push(item)
            }
        })
        if (newArr.length == 1) {
            newArr.forEach(item => {
                item.isDisBtn = true
            })
        } else {
            newArr.forEach(item => {
                item.isDisBtn = false
            })
        }
    }

}
